import React from 'react';
import { SyncSetupContainer} from '../../Containers/EmailContainer';

const SyncSetup = (props) => {
	return (
		<SyncSetupContainer />
	);
}

export default SyncSetup;